<template>
	<div class="con">
		<div class="head">
			<van-tabs v-model="headActive" color="#27bec4" @change="headBtn">
				<van-tab title="有效号"></van-tab>
				<van-tab title="过期号"></van-tab>
			</van-tabs>
		</div>
		<div class="list" v-if="list.length != ''">
			<div class="con-list" v-for="(item,index) in list" :key="'p'+index">
				<div class="list-disp">
					<label>就诊人：</label>
					<div class="name">{{item.BRXM}}</div>
				</div>
				<div class="list-disp">
					<label>医生：</label>
					<div>{{item.YGXM}}</div>
				</div>
				<div class="list-disp">
					<label>科室：</label>
					<div>{{item.KSMC}}</div>
				</div>
				<div class="list-disp">
					<label>类型：</label>
					<div>{{item.CZPB==1?'复诊':'初诊'}}</div>
				</div>
				<div class="list-disp">
					<label>就诊时间：</label>
					<div>
						<div>{{item.GHSJ}}</div>
						<!-- <div>{{item.GHLB == 1 ? '上午': '下午'}}</div> -->
					</div>
				</div>
				<div class="Level">{{item.CZLX}}</div>
				<div class="returnReg" v-if="headActive + 1 == 1" @click="returnRegBtn(item.BRID, item.SBXH, item.GHSJ, item.GHLB, item.KSDM, item.YSDM)">撤销</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无挂号记录~~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'regQuery',
		data() {
			return {
				msg: '预约挂号查询',
				headActive: 0,
				list: [],
				cardUserInfo: '',
				noImgShow: false
			}
		},
		methods: {
			/**
			 * 1.	获取微信预约挂号信息
			 * 2.    1-正在挂号信息 2-历史挂号信息
			 * */
			makeRegister() {
				this.$store.commit('Load', true)
				let status = this.headActive + 1;
				this.$Axios.Get('/outpatient/makeRegister?brid=' + this.cardUserInfo.brid + '&status=' + status, null).then(data => {
					console.log(data)
					this.$store.commit('Load', false)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							let List = data.msg;
							for(let i = 0, len = List.length; i < len; i++) {
								// List[i].GHLB = List[i].GHLB == '0' ? '上午' : '下午';
								// List[i].CZLX = List[i].CZLX == '0' ? '普通' : '专家';
								List[i].GHSJ = List[i].GHSJ.substring(0, 16);
							}
							this.list = List;
							this.noImgShow = false;
						} else {
							this.noImgShow = true;
						}

					} else {
						this.list = '';
						this.noImgShow = true;
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					this.noImgShow = true;
					console.log(err)
				})
			},
			//顶部导航
			headBtn(e) {
				this.headActive = e;
				this.list = '';
				this.noImgShow = false;
				this.makeRegister();
			},
			//撤销
			returnRegBtn(brid, sbxh, time, type, KSDM, ysid){
				let that = this;
				this.$dialog.confirm({
					title: '撤销',
					message: '确定撤销该挂号？'
				}).then(() => {
					this.$store.commit('Load', true)
					this.$Axios.Get('/outpatient/cancelMakeRegister?brid=' + brid + '&sbxh=' + sbxh + '&ghsj=' + time + '&ghlb=' + type + '&ksdm=' + KSDM + '&ysdm=' + ysid, null).then(res => {
						this.$store.commit('Load', false)
						console.log(res)
						if(res.code == 0){
							this.$toast('撤销成功')
							setTimeout(()=>{
								that.makeRegister();
							}, 300)
						}else{
							this.$toast(res.msg)
						}
					}).catch((err)=>{
						this.$store.commit('Load', false)
					})
						
				}).catch(() => {});
			},
		},
		mounted() {
			let that = this;
			if(localStorage.getItem('cardUserInfo') != undefined){
				this.cardUserInfo = JSON.parse(localStorage.getItem('cardUserInfo'));
				that.makeRegister()
			}
			
			
		},
		created() {},
	}
</script>

<style scoped>
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}
	
	.list {
		flex: 1;
		overflow-y: scroll;
	}
	
	.con-list {
		position: relative;
		padding: 10px;
		margin: 10px auto;
		width: 80%;
		border: 1px solid #ccc;
		border-radius: 10px;
		box-shadow: 2px 2px 2px #ccc;
		background: #fff;
		overflow: hidden;
	}
	
	.list-disp {
		display: flex;
		font-size: 14px;
		color: #000;
		margin: 10px 0;
	}
	
	.list-disp label {
		width: 100px;
		color: #666;
		text-align: end;
	}
	
	.list-disp>div {
		margin-left: 10px;
	}
	
	.level {
		color: #FF0000;
	}
	
	.Level {
		padding: 5px;
		position: absolute;
		right: -25px;
		top: 10px;
		width: 100px;
		background-color: #27BEC4;
		font-size: 14px;
		color: #fff;
		text-align: center;
		transform: rotate(45deg);
	}
	
	.name {
		font-size: 17px;
		font-weight: 700;
	}
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	.returnReg{
		padding: 2px 8px;
		position: absolute;
		right: 10px;
		bottom: 5px;
		font-size: 12px;
		color: #FF0000;
	}
</style>